export const THEME_MODE = {
	LIGHT: 'light',
	DARK: 'dark',
	SYSTEM: 'auto',
} as const;

export type ThemeValue = typeof THEME_MODE.LIGHT | typeof THEME_MODE.DARK;

/** Valid theme values for runtime validation */
const VALID_THEMES = new Set<string>([THEME_MODE.LIGHT, THEME_MODE.DARK]);

export function isValidTheme(value: unknown): value is ThemeValue {
	return typeof value === 'string' && VALID_THEMES.has(value);
}

/** Custom event name used for intra-frame theme synchronisation */
export const THEME_UPDATE_EVENT = 'THEME_UPDATE';
